<template>
  <v-container grid-list-md pa-0 ma-2 style="max-width: calc(100% - 16px)">
    <v-layout row wrap>
      <v-flex xs12 md4>
        <SelectCreditors
          :multiple="false"
          :selected="selectedCreditor"
          :negotiation="true"
          @selectedCreditors="changeSelectCreditors($event)"
        ></SelectCreditors>
      </v-flex>
      <v-flex xs12 md4>
        <v-text-field
          class="text-details-none"
          autocomplete="off"
          maxlength="80"
          placeholder="Pesquise por nome"
          @change="searchApproach()"
          v-model="nameFilter"
          value
          box
          label="Pesquisar"
          name="name"
        />
      </v-flex>
      <v-flex xs12 md3>
        <div class="d-flex align-center" style="height: 56px">
          <v-switch
            hide-details
            class="ma-0 pa-0"
            :class="$vuetify.breakpoint.mdAndUp ? 'justify-end' : 'justify-center'"
            :label="active ? 'Mostrar inativas' : 'Mostrar ativas'"
            @change="searchApproach()"
            v-model="active"
          ></v-switch>
        </div>
      </v-flex>
      <v-flex xs12 md12>
        <v-data-table
          :headers="headers"
          :rows-per-page-items="pagination.rowsPerPageItems"
          rows-per-page-text="Mostrar"
          align-center
          justify-center
          :items="approaches.objects"
          :total-items="totalItems"
          :pagination.sync="pagination"
          no-data-text="Nenhuma abordagem para este credor"
          style="border: 1px solid rgba(0, 0, 0, 0.12); border-radius: 4px"
        >
          <template slot="headerCell" slot-scope="props">
            <v-tooltip top dark>
              <template v-slot:activator="{ on }">
                <span v-on="on">{{ props.header.text }}</span>
              </template>
              <span v-if="props.header.tooltip">{{ props.header.tooltip }}</span>
            </v-tooltip>
          </template>
          <template slot="items" slot-scope="{ item }">
            <tr>
              <td :style="!item.active ? 'font-weight: 300; color: grey;' : ''">{{ item.creditor ? item.creditor.name : "" }}</td>
              <td class="td-flex">
                <div>
                  <p style="font-weight: 400"> {{ item.id + ". " + item.name }} </p>
                  <p style="font-weight: 200; color: grey; font-size:xx-small;"> Atualizado em: {{ item.updated_at | formatDateTime }} </p>
                </div>
                <div>
                  <v-tooltip top v-if="item.campaign">
                    <template v-slot:activator="{ on }">
                    <span
                        v-on="on"
                        :class="item.active ? 'blue lighten-4 blue--text text--darken-2' : 'grey lighten-4 grey--text text--darken-2'"
                        style="
                          font-size: 15px;
                          line-height: 12px;
                          padding: 2px 4px 2px 4px;
                          border-radius: 4px;
                          font-weight: 500;
                          margin-top: auto;
                          margin-left: 4px;
                        "
                      >
                        {{ item.campaign }}
                    </span> 
                    </template>
                    <span>Campanha</span>
                  </v-tooltip>
                  <v-tooltip top v-if="item.stimulus_length">
                    <template v-slot:activator="{ on }">
                    <span
                        v-on="on"
                        :class="item.active ? 'pink lighten-4 pink--text text--darken-2' : 'grey lighten-4 grey--text text--darken-2'"
                        style="
                          font-size: 15px;
                          line-height: 12px;
                          padding: 2px 4px 0px 4px;
                          border-radius: 4px;
                          font-weight: 500;
                          margin-top: auto;
                          margin-left: 4px;
                          cursor: pointer;
                        "
                        @click="
                          openModal(
                            'Estímulos vinculados',
                            item
                          )
                        "
                      >
                        {{ item.stimulus_length }} {{item.stimulus_length > 1 ? "estímulos" : "estímulo"}}
                    </span> 
                    </template>
                    <span>Quantidade de Estímulos Vinculados</span>
                  </v-tooltip>
                  
                  <v-tooltip top right v-if="item.events">
                    <template v-slot:activator="{ on }">
                    <span
                        v-on="on"
                        :class="item.active ? 'green lighten-4 green--text text--darken-2' : 'grey lighten-4 grey--text text--darken-2'"
                        style="
                          font-size: 15px;
                          line-height: 12px;
                          padding: 2px 4px 0px 4px;
                          border-radius: 4px;
                          font-weight: 500;
                          margin-top: auto;
                          margin-left: 4px;
                        "
                      >
                      {{ item.events }} {{item.events > 1 ? "eventos" : "evento"}} em {{ item.qtd_offset }} {{item.qtd_offset  > 1 ? "dias" : "dia"}}
                    </span> 
                    </template>
                    <span>Eventos e Offsets</span>
                  </v-tooltip>
                  <template>
                    <v-menu bottom left>
                      <template v-slot:activator="{ on }">
                        <v-btn icon v-on="on">
                          <v-icon>mdi-dots-vertical</v-icon>
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-tile @click="editApproach(item)">
                          <v-list-tile-title>Editar</v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile @click="cloneApproach(item)">
                          <v-list-tile-title>Clonar</v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile @click="openDialogArchivingApproachFlow(item)">
                          <v-list-tile-title>{{
                            !item.active ? "Ativar" : "Desativar"
                          }}</v-list-tile-title>
                        </v-list-tile>
                      </v-list>
                    </v-menu>
                  </template>
                </div>
              </td>            
            </tr>
            
          </template>
          <template v-slot:no-data>
            <v-container
              fluid
              fill-height
              style="background-color: rgba(255, 255, 255, 0.5)"
            >
              <v-layout justify-center align-center>
                <v-progress-circular
                  v-if="loading"
                  indeterminate
                  color="primary"
                ></v-progress-circular>
                <strong v-else class="py-2" style="font-color: red; font-size: 14px"
                  >Nenhuma abordagem encontrada</strong
                >
              </v-layout>
            </v-container>
          </template>
        </v-data-table>
      </v-flex>
      <v-btn
        color="accent"
        :disabled="!active"
        fixed
        bottom
        right
        fab
        @click="dialogNewApproach = true"
      >
        <v-icon>add</v-icon>
      </v-btn>
    </v-layout>
    <v-dialog scrollable v-model="dialogNewApproach" width="550">
      <v-card>
        <v-card-title class="headline" primary-title>
          {{ !isClone ? "Criar um novo fluxo de abordagem" : "Clonar para um novo fluxo de abordagem" }}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-container grid-list-md pa-0>
            <v-form ref="form" lazy-validation>
              <v-layout wrap>
                <v-flex xs12>
                  <v-text-field
                    box
                    required
                    label="Nome"
                    :rules="[(v) => !!v || 'O nome é obrigatório!']"
                    v-model="newApproach.name"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-select
                    box
                    clearable
                    label="Credor"
                    item-text="name"
                    item-value="creditor_id"
                    :items="creditors.objects"
                    :rules="requiredRule.concat([(v) => !isCreditorChanged || 'Você está clonando esse fluxo para outro credor, verifique as abordagens e as variáveis antes de vincular à um estímulo!'])"
                    @change="isCreditorChanged = isClone"
                    v-model="newApproach.creditor_id"
                  ></v-select>
                </v-flex>
                <v-flex xs12>
                  <v-switch hide-details v-model="isCampaign" class="pt-0 mt-0">
                    <template v-slot:label>
                      <div class="d-flex align-center ml-2">
                        <p class="mb-0 subheading">É uma campanha?</p>
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-icon color="grey" class="ml-1" dark v-on="on"
                              >mdi-help-circle</v-icon
                            >
                          </template>
                          <span>
                            Se for definido como campanha, os clientes entrarão em<br />
                            um novo fluxo desde o início, utilize isso para campanhas<br />
                            bem específicas como por exemplo: "Blackfriday"
                          </span>
                        </v-tooltip>
                      </div>
                    </template>
                  </v-switch>
                </v-flex>
                <v-flex xs12 v-if="isCampaign">
                  <v-text-field
                    box
                    label="Campanha"
                    style="width: 100%"
                    :rules="[(v) => !!v || 'A campanha é obrigatório!']"
                    v-model="newApproach.campaign"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-form>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" outline @click="dialogNewApproach = false; isClone = false; isCreditorChanged = false">
            Fechar
          </v-btn>
          <v-btn
            class="elevation-0"
            :disabled="
              !(
                newApproach.name &&
                newApproach.creditor_id &&
                (!isCampaign || newApproach.campaign)
              )
            "
            color="primary"
            @click="addApproach"
          >
            {{ !isClone ? "Salvar" : "Clonar" }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Dialog para arquivar abordagens-->
    <DialogArchivingApproachFlow
      :active="activeApproachFlow"
      :dialog.sync="dialogArchivingApproachFlow"
      @archiveNode="updateStatus"
    />
    <v-dialog v-model="dialog" scrollable width="500">
      <v-card>
        <v-toolbar class="elevation-0">
          <v-toolbar-title>{{ title }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <!-- <v-toolbar-items>
          </v-toolbar-items> -->
          <v-btn icon @click="dialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pa-0" style="max-height: 80vh">
          <v-list dense v-if="list.length">
            <template v-for="(item, index) in list">
              <v-list-tile :key="item.id" avatar ripple @click="goTo(item)">
                <v-list-tile-content>
                  <v-list-tile-title :class="
                      item.active_at
                      ? 'black--text'
                      : 'grey--text'
                  ">{{ item.id }}. {{ item.name }}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-divider v-if="index + 1 < list.length" :key="index * 9999"></v-divider>
            </template>
          </v-list>
          <div v-else class="my-5 d-flex justify-center grey--text text--darken-2">
            Não há dados para carregar.
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import store from "@/store";
import approachService from "@/services/consolidation-tree/approach-flow";
import ApproachFlowRuleService from "@/services/consolidation-tree/approach-flow-rule";
import stimulusService from "@/services/consolidation-tree/stimulus";
import creditorService from "@/services/creditor";
import SelectCreditors from "@/components/creditor/SelectCreditors";
import DialogArchivingApproachFlow from "./components/dialogs/dialogArchivingApproachFlow.vue";

export default {
  components: {
    SelectCreditors,
    DialogArchivingApproachFlow
},
  data() {
    return {
      requiredRule: [(v) => !!v || 'O credor é obrigatório!'],
      dialog: false,
      list: [],
      title: "",
      active: true,
      fab: false,
      dialog: false,
      loading: false,
      isCampaign: false,
      doneFetching: false,
      dialogNewApproach: false,
      dialogArchivingApproachFlow: false,
      nameFilter: null,
      approachFlow: null,
      activeApproachFlow: "",
      dataDialogArchivingApproachFlow: {},
      approach_name: "",
      totalItems: 0,
      selectedCreditor: 0,
      nameFilter: null,
      approach_id: null,
      approachsTypes: [],
      selectedApproachsTypes: [],
      query: {},
      creditors: {},
      approach_rule: {},
      isClone: false,
      isCreditorChanged: false,
      newApproach: {
        active: true,
        name: "",
        type: "",
        campaign: "",
        creditor_id: "",
        notify_type: "",
        approach_rules: {},
        configurations: {},
      },
      pagination: {
        descending: true,
        page: 1,
        rowsPerPage: 25,
        sortBy: "updated_at",
        rowsPerPageItems: [10, 25, 50, 100],
      },
      approaches: {
        objects: [],
      },
      stimulus: [],
      headers: [
        {
          text: "Credor",
          align: "left",
          value: "creditor.name",
          tooltip: "Nome do credor",
          sortable: true,
          width: "20%",
        },
        {
          text: "Abordagem",
          align: "left",
          value: "name",
          tooltip: "Titulo da abordagem",
          sortable: false,
          width: "80%",
        },
      ],
    };
  },
  async created() {
    await this.getStimulus();
    await this.getCreditors();
    this.query = this.$route.query;
    if (this.query && Object.keys(this.query).length == 0) {
      this.query = store.getters.getApproachesFlowFilters;
    }
    if (this.query) {
      if (this.query.sortBy) this.pagination.sortBy = this.query.sortBy;
      if (this.query.descending) this.pagination.descending = this.query.descending;
      if (this.query.rowsPerPage) this.pagination.rowsPerPage = this.query.rowsPerPage;
      if (this.query.page) this.pagination.page = this.query.page;
      if (this.query.nameFilter && this.query.nameFilter.length)
        this.nameFilter = this.query.nameFilter;
      if (this.query.types) {
        this.query.types.split(",").forEach((id) => {
          this.selectedApproachsTypes.push(id);
        });
      if (this.query.nameFilter && this.query.nameFilter.length)
        this.nameFilter = this.query.nameFilter;
      }
      if (this.query && this.query.active) {
        if (typeof this.query.active == "string") {
          this.active = JSON.parse(this.query.active.toLowerCase());
        } else {
          this.active = this.query.active;
        }
      }
      if (this.query.descending) {
        if (typeof this.query.descending == "string") {
          this.descending = JSON.parse(this.query.descending.toLowerCase());
        } else {
          this.descending = this.query.descending;
        }
      }
      if (this.query.creditor) {
        this.selectedCreditor = parseInt(this.query.creditor);
        this.query.creditor = this.selectedCreditor;
      }
    }
    await this.searchApproach();
    this.query.active = this.active;     
    this.doneFetching = true;
  },
  watch: {
    pagination: {
      async handler() {
        if (this.doneFetching) {
          this.addfilters();

          await this.searchApproach();
        }
      },
      deep: true,
    },
    dialogNewApproach() {
      if (!this.dialogNewApproach) {
        this.newApproach = {
          active: true,
          name: "",
          type: "",
          campaign: "",
          creditor_id: "",
          notify_type: "",
          approach_rules: {},
          configurations: {},
        };
        this.$refs.form.reset();
      }
    },
  },
  methods: {
    async getStimulus() {
      this.stimulus = await stimulusService.list();
    },
    changeSelectCreditors(event) {
      this.selectedCreditor = event;
      this.searchApproach();
    },
    async archiveApproachFlow(approachFlow){
      this.activeApproachFlow = approachFlow.active;
      this.dialogArchivingApproachFlow = true;
    },
    openDialogArchivingApproachFlow(approachFlow){
      this.approachFlow = approachFlow;
      this.activeApproachFlow = approachFlow.active;
      this.dialogArchivingApproachFlow = true;
    },
    async updateStatus() {
      let approachToSave = {
        active: !this.approachFlow.active,
        id: this.approachFlow.id,
      };

      await approachService
        .save(approachToSave)
        .then(async (res) => {
          let message = "";
          this.approachFlow.active = res.active;

          message = this.approachFlow.active
            ? `Fluxo de abordagem ${this.approachFlow.name} ativado!`
            : `Fluxo de abordagem ${this.approachFlow.name} desativado!`;
          this.$store.commit("showSnackbar", {
            message,
            important: true,
          });
          this.searchApproach();
          if (res == undefined) {
            this.$store.commit("showSnackbar", "Houve um erro ao salvar");
            return console.error("houve um erro");
          }
        })
        .catch((error) => {
          this.$store.commit("showSnackbar", "Houve um erro ao salvar");
          console.error("Houve um erro", error);
        });
    },
    async searchApproach() {
      this.addfilters();

      if (this.loading) return;
      this.loading = true;

      await approachService
        .list(
          this.selectedCreditor,
          this.pagination,
          this.active,
          this.nameFilter
        )
        .then((res) => {
          this.approaches = res;
          this.totalItems = res.num_results;

          this.approaches.objects.forEach((approach) => {
            let offsets = [];        
            approach.stimulus = this.stimulus.objects.filter((s) => s.approach_flow_id == approach.id)
            .filter((s) => s.debt_node.active && s.debt_node.debt_base.status == "STIMULATE");
            approach.stimulus_length = approach.stimulus.length;
            approach.events = approach.approach_rules.length;
            approach.approach_rules.forEach((ar) =>{
              offsets.push(ar.offset);
            }
            )
            offsets = [...new Set(offsets)];
            approach.qtd_offset = offsets.length;
        });
        })
        .catch((error) => {
          console.error(error);
          this.$store.commit("showSnackbar", "Houve um erro ao buscar os dados");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    addfilters() {
      this.query = {};
      this.query.rowsPerPage = this.pagination.rowsPerPage;
      this.query.page = this.pagination.page;
      if (this.pagination.descending) this.query.descending = this.pagination.descending;
      if (this.pagination.sortBy) this.query.sortBy = this.pagination.sortBy;
      else this.query.sortBy = 0;
      if (this.selectedCreditor > 0) this.query.creditor = this.selectedCreditor;
      if (this.selectedApproachsTypes.length > 0)
        this.query.types = this.selectedApproachsTypes.map((sp) => sp).join(",");
      this.query.active = this.active;
      if (this.nameFilter && this.nameFilter.length)
        this.query.nameFilter = this.nameFilter;
      this.$store.commit("setApproachesFlowFilters", this.query);
      if (this.$route.path == "/debt-tree/approach-flow") {
        this.$router.replace({
          name: "Fluxos de abordagem",
          query: this.query,
        });
      }
    },
    addApproach() {
      this.isCreditorChanged = false;
      if (!this.$refs.form.validate()) return;
      this.newApproach.campaign = this.newApproach.campaign
        ? this.newApproach.campaign
        : null;
      this.searchApproach();
      approachService
        .save(this.newApproach)
        .then((res) => {
          if(this.newApproach.approach_rules.length) this.addRules(this.newApproach.approach_rules, res.id);
          this.dialogNewApproach = false;
          this.$router.push({
            name: "Fluxo de abordagem",
            params: {
              edit: true,
              approach_id: res.id,
            },
          });
        })
        .catch((error) => {
          console.error(error);
          this.$store.commit("showSnackbar", {
            message: "Houve um erro ao salvar",
          });
        });
        this.isClone = false;
        this.isCreditorChanged = false;
    },
    editApproach(approach) {
      this.$router.push({
        name: "Fluxo de abordagem",
        params: {
          edit: true,
          approach_id: approach.id,
        },
      });
    },
    async getCreditors() {
      await creditorService
        .list()
        .then((res) => {
          this.creditors = res;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    cloneApproach(approach){
      this.isClone = true;
      this.newApproach = {
          active: true,
          name: "CLONE - " + approach.name,
          type: "",
          campaign: approach.campaign,
          creditor_id: approach.creditor_id,
          notify_type: "",
          approach_rules: approach.approach_rules,
          configurations: approach.configurations ? approach.configurations : {},
        };
      this.isCampaign = approach.campaign ? true : false;
      this.dialogNewApproach = true;
    },
    addRules(rules, approachId){
      
      rules.forEach(rule => 
      {
        this.approach_rule = {
          approach_flow_id: approachId,
          offer_type_id: rule.offer_type_id ? rule.offer_type_id : null,
          offset: rule.offset,
          stimulus: rule.stimulus,
          time: rule.time,
          type: rule.type
        };
        ApproachFlowRuleService.save(this.approach_rule);
      }
      );
    },
    openModal(title, row) {
      this.title = title;
      this.list = row.stimulus;
      this.list.forEach((l) => (l.creditor_id = row.creditor_id));
      this.dialog = true;
    },
    goTo(item) {
      let url = "/debt-tree/";
    
      url +=
        "stimulus?creditor=" +
        item.creditor_id +
        "&baseId=" +
        item.debt_node.debt_base_id;
      
      this.$router.push(url);
    },
  },
};
</script>

<style>
.v-datatable__actions__range-controls {
  margin-right: 8%;
}
</style>

<style scoped lang="scss">
.td-flex {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  height: 100% !important;
  @media (min-width: 900px) {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
}
</style>
